const data = [
    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    [11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
    [21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
    [31, 32, 33, 34, 35, 36, 37, 38, 39, 40],
    [41, 42, 43, 44, 45, 46, 47, 48, 49, 50],
    [51, 52, 53, 54, 55, 56, 57, 58, 59, 60],
    [61, 62, 63, 64, 65, 66, 67, 68, 69, 70],
    [71, 72, 73, 74, 75, 76, 77, 78, 79, 80],
    [81, 82, 83, 84, 85, 86, 87, 88, 89, 90],
    [91, 92, 93, 94, 95, 96, 97, 98, 99, 100]
];

export const HEAT_MAP_CHART_SERIES = [
    {
        name: '',
        data: data[0]
    },
    {
        name: '36%',
        data: data[1]
    },
    {
        name: '',
        data: data[2]
    },
    {
        name: '34%',
        data: data[3]
    },
    {
        name: '',
        data: data[4]
    },
    {
        name: '',
        data: data[5]
    },
    {
        name: '',
        data: data[6]
    },
    {
        name: '25%',
        data: data[7]
    },
    {
        name: '',
        data: data[8]
    },
    {
        name: '4%',
        data: data[9]
    }
];

export const DIGITAL_AFFINITY_HEAT_MAP_CHART_OPTIONS = {
    chart: {
        type: 'heatmap',
        animations: { enabled: false },
        toolbar: { show: false }
    },
    dataLabels: { enabled: false },
    plotOptions: {
        heatmap: {
            enableShades: false,
            colorScale: {
                ranges: [
                    {
                        from: 1,
                        to: 36,
                        color: '#FEDF89',
                        name: 'Low'
                    },
                    {
                        from: 37,
                        to: 70,
                        color: '#F79009',
                        name: 'Medium'
                    },
                    {
                        from: 71,
                        to: 96,
                        color: '#B54708',
                        name: 'High'
                    },
                    {
                        from: 97,
                        to: 100,
                        color: '#7A2E0E',
                        name: 'Very High'
                    }
                    // {
                    //     name: '1%',
                    //     color: '#F79009',
                    // },
                ]
            }
        }
    },
    xaxis: {
        categories: ['', '', '', '', '', '', '', '', '', ''],
        crosshairs: { show: false },
        axisTicks: { show: false },
        axisBorder: { show: false }
    },
    yaxis: {
        opposite: true,
        labels: { style: { textAlign: 'right' } }
    },
    legend: {
        position: 'left',
        labels: {
            colors: '#667085',
            useSeriesColors: false
        },
        fontSize: '14px',
        fontWeight: 400
    },
    grid: {
        show: false,
        padding: {
            top: 0,
            bottom: 0
        },
        xaxis: { lines: { show: false } },
        yaxis: { lines: { show: false } }
    },
    tooltip: { enabled: false },
    states: {
        hover: {
            filter: {
                type: 'none',
                value: 0
            }
        }
    },
    responsive: [
        {
            breakpoint: 1280,
            options: {
                legend: { fontSize: '10px' },
                yaxis: {
                    opposite: true,
                    labels: { style: { fontSize: '10px' } }
                }
            }
        }
    ]
};

export const PERSONAL_PROMOTION_HEAT_MAP_CHART_OPTIONS = {
    chart: {
        type: 'heatmap',
        animations: { enabled: false },
        toolbar: { show: false }
    },
    dataLabels: { enabled: false },
    plotOptions: {
        heatmap: {
            enableShades: false,
            colorScale: {
                ranges: [
                    {
                        from: 1,
                        to: 36,
                        color: '#A6F4C5',
                        name: 'Low'
                    },
                    {
                        from: 37,
                        to: 70,
                        color: '#12B76A',
                        name: 'Medium'
                    },
                    {
                        from: 71,
                        to: 96,
                        color: '#027A48',
                        name: 'High'
                    },
                    {
                        from: 97,
                        to: 100,
                        color: '#054F31',
                        name: 'Very High'
                    }
                    // {
                    //     name: '1%',
                    //     color: '#12B76A',
                    // },
                ]
            }
        }
    },
    xaxis: {
        categories: ['', '', '', '', '', '', '', '', '', ''],
        crosshairs: { show: false },
        axisTicks: { show: false },
        axisBorder: { show: false }
    },
    yaxis: {
        opposite: true,
        labels: { style: { textAlign: 'right' } }
    },
    legend: {
        position: 'left',
        labels: {
            colors: '#667085',
            useSeriesColors: false
        },
        fontSize: '14px',
        fontWeight: 400
    },
    grid: {
        show: false,
        padding: {
            top: 0,
            bottom: 0
        },
        xaxis: { lines: { show: false } },
        yaxis: { lines: { show: false } }
    },
    tooltip: { enabled: false },
    states: {
        hover: {
            filter: {
                type: 'none',
                value: 0
            }
        }
    },
    responsive: [
        {
            breakpoint: 1280,
            options: {
                legend: { fontSize: '10px' },
                yaxis: {
                    opposite: true,
                    labels: { style: { fontSize: '10px' } }
                }
            }
        }
    ]
};

export const PEER_TO_PEER_HEAT_MAP_CHART_OPTIONS = {
    chart: {
        type: 'heatmap',
        animations: { enabled: false },
        toolbar: { show: false }
    },
    dataLabels: { enabled: false },
    plotOptions: {
        heatmap: {
            radius: 3,
            enableShades: false,
            colorScale: {
                ranges: [
                    {
                        from: 1,
                        to: 36,
                        color: '#B9E6FE',
                        name: 'Low'
                    },
                    {
                        from: 37,
                        to: 70,
                        color: '#0BA5EC',
                        name: 'Medium'
                    },
                    {
                        from: 71,
                        to: 96,
                        color: '#026AA2',
                        name: 'High'
                    },
                    {
                        from: 97,
                        to: 100,
                        color: '#0B4A6F',
                        name: 'Very High'
                    }
                    // {
                    //     name: '1%',
                    //     color: '#0BA5EC',
                    // },
                ]
            }
        }
    },
    xaxis: {
        categories: ['', '', '', '', '', '', '', '', '', ''],
        crosshairs: { show: false },
        axisTicks: { show: false },
        axisBorder: { show: false }
    },
    yaxis: {
        opposite: true,
        labels: { style: { textAlign: 'right' } }
    },
    legend: {
        position: 'left',
        labels: {
            colors: '#667085',
            useSeriesColors: false
        },
        fontSize: '14px',
        fontWeight: 400
    },
    grid: {
        show: false,
        padding: {
            top: 0,
            bottom: 0
        },
        xaxis: { lines: { show: false } },
        yaxis: { lines: { show: false } }
    },
    tooltip: { enabled: false },
    states: {
        hover: {
            filter: {
                type: 'none',
                value: 0
            }
        }
    },
    responsive: [
        {
            breakpoint: 1280,
            options: {
                legend: { fontSize: '10px' },
                yaxis: {
                    opposite: true,
                    labels: { style: { fontSize: '10px' } }
                }
            }
        }
    ]
};

export const AFFINITY_HEAT_MAP_CHART_OPTIONS = {
    chart: {
        type: 'heatmap',
        animations: { enabled: false },
        toolbar: { show: false }
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    dataLabels: { enabled: false },
    plotOptions: {
        heatmap: {
            enableShades: false,
            colorScale: { ranges: [] }
        }
    },
    xaxis: {
        categories: ['', '', '', '', '', '', '', '', '', ''],
        crosshairs: { show: false },
        axisTicks: { show: false },
        axisBorder: { show: false }
    },
    yaxis: {
        opposite: true,
        labels: {
            formatter: function (value) {
                const isNumber = typeof value === 'number';
                let valueToShow = '';
                if(isNumber && Number(value) > 1){
                    valueToShow = Number(value) + '%';
                }

                return valueToShow;
            },
            style: { textAlign: 'right' }
        }
    },
    legend: {
        position: 'left',
        inverseOrder: true,
        labels: {
            colors: '#667085',
            useSeriesColors: false
        },
        fontSize: '14px',
        fontWeight: 400
    },
    grid: {
        show: false,
        padding: {
            top: 0,
            bottom: 0
        },
        xaxis: { lines: { show: false } },
        yaxis: { lines: { show: false } }
    },
    tooltip: { enabled: false },
    states: {
        hover: {
            filter: {
                type: 'none',
                value: 0
            }
        }
    }
    // responsive: [
    //     {
    //       breakpoint: 1280,
    //       options: {
    //         legend: {
    //             fontSize: '10px',
    //         },
    //         yaxis: {
    //             opposite: true,
    //             labels: {
    //                 formatter: function (value) {
    //                     let isNumber = typeof value === 'number';
    //                     let valueToShow = "";
    //                     if(isNumber && Number(value) > 1){
    //                         valueToShow = Number(value) + '%';
    //                     }
        
    //                     return valueToShow;
    //                 },
    //                 style: {
    //                     fontSize: '10px',
    //                 },
    //             },
    //         },
    //       }
    //     }
    // ]
};

export const PIE_CHART_SERIES = [36, 34, 25, 4];

export const DIGITAL_AFFINITY_PIE_CHART_OPTIONS = {
    chart: {
        type: 'pie',
        animations: { enabled: false },
        toolbar: { show: false }
    },
    tooltip: {
        enabled: true,
        fillSeriesColor: false,
        style: {
            color: '#fff',
            fontSize: '10px',
            fontWeight: 400
        }
    },
    dataLabels: {
        dropShadow: { enabled: false },
        style: {
            colors: ['#000'], 
            fontSize: '12px'
        },
        formatter: function (val, opts) {
            return val.toFixed(2) + '%';
        }
    },
    legend: {
        position: 'left',
        labels: {
            colors: '#667085',
            useSeriesColors: false
        },
        fontSize: '14px',
        fontWeight: 400
    },
    labels: ['Low', 'Medium', 'High', 'Very High'],
    colors: ['#FEDF89', '#F79009', '#B54708', '#7A2E0E'], 
    plotOptions: {
        pie: {
            dataLabels: {
                offset: -10,
                minAngleToShowLabel: 10,
                maxAngleToShowLabel: 180,
                hideOverflowingLabels: true,
                outsidePadding: 8,
                insidePadding: 8
            }
        }
    },
    responsive: [
        {
            breakpoint: 1280,
            options: {
                legend: { fontSize: '10px' },
                yaxis: {
                    opposite: true,
                    labels: { style: { fontSize: '10px' } }
                }
            }
        }
    ]
};

export const PERSOMAL_PROMOTION_PIE_CHART_OPTIONS = {
    chart: {
        type: 'pie',
        animations: { enabled: false },
        toolbar: { show: false }
    },
    tooltip: {
        enabled: true,
        fillSeriesColor: false,
        style: {
            color: '#fff',
            fontSize: '10px',
            fontWeight: 400
        }
    },
    dataLabels: {
        dropShadow: { enabled: false },
        style: {
            colors: ['#000'], 
            fontSize: '12px'
        },
        formatter: function (val, opts) {
            return val.toFixed(2) + '%';
        }
    },
    legend: {
        position: 'left',
        labels: {
            colors: '#667085',
            useSeriesColors: false
        },
        fontSize: '14px',
        fontWeight: 400
    },
    labels: ['Low', 'Medium', 'High', 'Very High'],
    colors: ['#A6F4C5', '#12B76A', '#027A48', '#054F31'], 
    plotOptions: {
        pie: {
            dataLabels: {
                offset: -10,
                minAngleToShowLabel: 10,
                maxAngleToShowLabel: 180,
                hideOverflowingLabels: true,
                outsidePadding: 8,
                insidePadding: 8
            }
        }
    },
    responsive: [
        {
            breakpoint: 1280,
            options: {
                legend: { fontSize: '10px' },
                yaxis: {
                    opposite: true,
                    labels: { style: { fontSize: '10px' } }
                }
            }
        }
    ]
};

export const PEER_TO_PEER_PIE_CHART_OPTIONS = {
    chart: {
        type: 'pie',
        animations: { enabled: false },
        toolbar: { show: false }
    },
    tooltip: {
        enabled: true,
        fillSeriesColor: false,
        style: {
            color: '#fff',
            fontSize: '10px',
            fontWeight: 400
        }
    },
    dataLabels: {
        dropShadow: { enabled: false },
        style: {
            colors: ['#000'], 
            fontSize: '12px'
        },
        formatter: function (val, opts) {
            return val.toFixed(2) + '%';
        }
    },
    legend: {
        position: 'left',
        labels: {
            colors: '#667085',
            useSeriesColors: false
        },
        fontSize: '14px',
        fontWeight: 400
    },
    labels: ['Low', 'Medium', 'High', 'Very High'],
    colors: ['#B9E6FE', '#0BA5EC', '#026AA2', '#0B4A6F'], 
    plotOptions: {
        pie: {
            dataLabels: {
                offset: -10,
                minAngleToShowLabel: 10,
                maxAngleToShowLabel: 180,
                hideOverflowingLabels: true,
                outsidePadding: 8,
                insidePadding: 8
            }
        }
    },
    responsive: [
        {
            breakpoint: 1280,
            options: {
                legend: { fontSize: '10px' },
                yaxis: {
                    opposite: true,
                    labels: { style: { fontSize: '10px' } }
                }
            }
        }
    ]
};